import { StoreAction } from "../../../types/store"
import { LengthPlayer, PlayersList } from "../lib/players"

export type SetCurrentQuickSearchAction = StoreAction & {
  currentQuickSearch: string
}
export const SET_CURRENT_QUICKSEARCH = "SET_CURRENT_QUICKSEARCH"
export const setCurrentQuickSearch = (currentQuickSearch: string): SetCurrentQuickSearchAction => ({
  type: SET_CURRENT_QUICKSEARCH,
  currentQuickSearch,
})

export type SetPlayersAction = StoreAction & { players: PlayersList[] }
export const SET_PLAYERS_LIST = "SET_PLAYERS_LIST"
export const setPlayersList = (players: PlayersList[]): SetPlayersAction => ({
  type: SET_PLAYERS_LIST,
  players,
})

export type SetLengthPlayerAction = StoreAction & { lengthPlayer: LengthPlayer }
export const SET_LENGTH_PLAYER = "SET_LENGTH_PLAYER"
export const setLengthPlayer = (lengthPlayer: LengthPlayer): SetLengthPlayerAction => ({
  type: SET_LENGTH_PLAYER,
  lengthPlayer,
})
